(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MIN_TWO_COL = 682;

    class Timeline {
      constructor(root) {
        this.root  = root;
        this.items = root.querySelector('.timeline__items');
        this.rows  = Array.from(root.querySelectorAll('.timeline__item'));
        this.raf   = null;
        this.schedule = this.schedule.bind(this);

        this.ro = new ResizeObserver(this.schedule);
        this.rows.forEach(r => {
          const card = r.querySelector('.timeline-card');
          if (card) this.ro.observe(card);
        });
        this.ro.observe(this.items);

        window.addEventListener('resize', this.schedule);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.schedule);
        this.schedule();
      }

      cssVar(name, fallback) {
        return parseFloat(getComputedStyle(this.root).getPropertyValue(name)) || fallback;
      }

      schedule() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = null; this.layout(); });
      }

      layout() {
        if (this.items.clientWidth < MIN_TWO_COL) {
          this.root.classList.remove('timeline--js');
          this.rows.forEach(r => (r.style.top = ''));
          this.items.style.height = '';
          return;
        }
        this.root.classList.add('timeline--js');

        const rowHeight = this.cssVar('--row-step', 120); 
        const gap       = this.cssVar('--card-gap', 32);

        const cards = this.rows.map(row => {
          const card = row.querySelector('.timeline-card');
          return {
            row,
            side: row.classList.contains('timeline__item--left') ? 'left' : 'right',
            h: card ? card.offsetHeight : 0,
          };
        });

        let step = rowHeight;
        const lastOnSide = { left: -1, right: -1 };
        cards.forEach((c, i) => {
          const prev = lastOnSide[c.side];
          if (prev !== -1) {
            const need  = cards[prev].h / 2 + gap + c.h / 2;
            const slots = i - prev;
            step = Math.max(step, need / slots);
          }
          lastOnSide[c.side] = i;
        });

        const center = cards.map((_, i) => i * step);

        let minTop = Infinity, maxBottom = -Infinity;
        cards.forEach((c, i) => {
          minTop    = Math.min(minTop, center[i] - c.h / 2);
          maxBottom = Math.max(maxBottom, center[i] + c.h / 2);
        });

        const shift   = -minTop;
        const halfRow = rowHeight / 2;
        cards.forEach((c, i) => {
          c.row.style.top = Math.round(center[i] + shift - halfRow) + 'px';
        });
        this.items.style.height = Math.round(maxBottom - minTop) + 'px';
      }
    }

    function init() {
      document.querySelectorAll('.timeline').forEach(el => {
        if (!el.__timeline) el.__timeline = new Timeline(el);
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
